import { useCallback } from 'react';

import { useBridgewayApi } from '@/api/BridgewayApi';
import { logger } from '@/logger';

/**
 * Appends an uploaded image to the brand imagery library
 * (business_profile.brand_identity.image_urls) so it shows up in Brand space →
 * Visual Identity → Imagery and in the email editor's brand-image picker.
 *
 * The call is fire-and-forget on purpose: it hangs off an image upload the user
 * already sees succeed (a chat attachment, a product photo, an email image), so
 * a library-append failure must never reject to the caller or surface an error
 * — that would read as if the upload itself failed. The server dedups by url, so
 * retries and the Imagery card's own whole-array save never create duplicates.
 */
export function useAddImageToLibrary(userId: string | undefined) {
	const api = useBridgewayApi();

	return useCallback(
		(url: string, source = 'upload'): void => {
			if (!userId || !url) return;
			void api
				.post(`/api/user/${userId}/business-profile/imagery`, {
					url,
					alt_text: '',
					source,
				})
				.catch((err) => logger.error('Failed to add image to library', err));
		},
		[api, userId],
	);
}
